import React from "react";
import * as RoomS from "./styles/roomsS";
import Accord from "../components/roomsSection/accordion/Accord";

const Rooms = () => {
  return (
    <>
      <RoomS.Wrapper />
      <Accord />
    </>
  );
};

export default Rooms;
